<template>
  <BaseAlert v-if="isNetworkError" variant="danger" :icon="LinkSlashIcon">
    {{ $t("Network error. Please check your internet connection.") }}
  </BaseAlert>

  <BaseAlert v-else variant="danger">
    <div>
      <span>{{ $t("An error occurred during load") }}</span>
      <div v-if="error" class="text-xs font-thin">
        {{ errorStatusCode }} {{ errorMessage || errorData }}
      </div>
    </div>
  </BaseAlert>
</template>

<script setup>
import { LinkSlashIcon } from "@heroicons/vue/24/solid/index";
import BaseAlert from "~/components/common/BaseAlert.vue";

const props = defineProps({
  error: {
    required: false,
    type: Object,
    default: null,
  },
});

const errorData = computed(() => props.error?.data || null);
const errorMessage = computed(() => errorData.value?.message || null);
const errorStatusCode = computed(() => props.error?.statusCode || null);
const isNetworkError = computed(
  () =>
    props.error?.toString().includes("<no response>") ||
    props.error?.toString().includes("Load failed"),
);
</script>
